
// Path: src/api/category/categoryApi.ts
import axios from 'axios';
import { API_URL } from '../../common/enum/enum';

export const getCategories = () => {
    return axios.get(`${API_URL.HOST}/category`);
}
